import CircularProgress from '@mui/material/CircularProgress';
import { Box, Typography } from '@mui/material';

import { THOR_COLORS } from '@/theme/thorTheme';

export default function Loading({ isLoading }: { isLoading?: boolean }) {
  return (
    isLoading &&
    (() => {
      console.log('🌀 [Scene] Rendering loading overlay');
      return (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(10, 50, 53, 0.95)',
            zIndex: 9999,
            gap: 3,
          }}
        >
          <CircularProgress
            size={60}
            thickness={4}
            sx={{
              color: THOR_COLORS.pink,
            }}
          />
          <Typography
            variant="h6"
            sx={{
              color: THOR_COLORS.cream,
              textAlign: 'center',
              px: 3,
            }}
          >
            Loading scene...
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: THOR_COLORS.cream,
              opacity: 0.7,
              textAlign: 'center',
              px: 3,
            }}
          >
            Downloading and extracting assets
          </Typography>
        </Box>
      );
    })()
  );
}
